const MerchantId = "13643959858";
const APIKEY = "IFPYZ1PK";
const PublicKey =
  "RzAwMDA3MDgyNzN8MTM2NDM5NTk4NTh8MGE4MGM4OTBmOWE0ZDdhN2E1ZDBjNDA2OGZhNDgwMmRlYTFiODIwNWEyYTBkYWI0MzMzNjEwYzBhNDU1Y2E4M2E4ZTY5Y2I0ZTY2NjhhNjYwMGNkOTg2MTI2MjIyM2M5ODE3NDExMmZmMDQ2NGVkNGI3ZjBjNDlhMWViOGNiNjA=";
const ServiceTypeName = "Screening Fee";
const ServiceTypeId = "13641881481";

export { MerchantId, APIKEY, PublicKey, ServiceTypeName, ServiceTypeId };
